import { updateUserEmail, updateUserPhone } from '@/api/myProfile'
import { checkMembershipContract, checkMembershipFeatures } from '@/api/myTermine'
import { phoneEmtpyText } from '@/utils/constants'

function defaultOverviewState() {
  return {
    timerStartTime: null,
    membershipFeaturesText: '',
    membershipContractText: [],
    userEmailError: null,
    finalPhone: phoneEmtpyText,
    finalEmail: null,
    savedPhone: {
      update: false,
      phone: '',
      error: false,
      opened: false,
    },
    savedEmail: {
      update: false,
      email: '',
      error: false,
      opened: false,
    },
  }
}

export default {
  state: () => ({
    ...defaultOverviewState(),
  }),
  actions: {
    async checkMembershipFeatures({ commit }) {
      try {
        const response = await checkMembershipFeatures()
        commit('setMembershipFeaturesText', response.data.text)
      } catch (error) {
        console.error(error)
      }
    },
    async checkMembershipContract({ commit, rootGetters }, dienstleistungsangebotId) {
      const params = {
        dienstleistungsangebotId,
        kfzartId: rootGetters.kfzartId,
      }

      try {
        const response = await checkMembershipContract(params)
        commit('addMembershipContractText', response.data.text)
      } catch (error) {
        console.error(error)
      }
    },
    async updateUserPhone({ commit, state, rootState }, phone) {
      const payload = {
        ...rootState.user.userAccountInfo.address,
        dateOfBirth: rootState.user.userAccountInfo.dateOfBirth,
        title: rootState.user.userAccountInfo.title,
        firstName: rootState.user.userAccountInfo.firstName,
        phone: phone,
        salutation: rootState.user.userAccountInfo.salutation,
        lastName: rootState.user.userAccountInfo.lastName,
      }
      commit('setUserAccountInfo', { ...state.userAccountInfo, phone: phone })
      try {
        await updateUserPhone(payload)
      } catch (error) {
        console.error(error)
      }
    },
    async updateUserEmail({ commit }, email) {
      commit('setUserEmailError', null)
      try {
        await updateUserEmail({ email: email })
        commit('setUserEmailError', false)
      } catch (error) {
        commit('setUserEmailError', 'Ungültige E-mail')
        console.error(error)
      }
    },
  },
  mutations: {
    resetOverviewState(state) {
      Object.assign(state, {
        ...state,
        ...defaultOverviewState(),
      })
    },
    setTimerStartTime(state, payload) {
      state.timerStartTime = payload
    },
    setMembershipFeaturesText(state, payload) {
      state.membershipFeaturesText = payload
    },
    addMembershipContractText(state, payload) {
      state.membershipContractText.push(payload)
    },
    clearMembershipContractText(state) {
      state.membershipContractText = []
    },
    setUserEmailError(state, payload) {
      state.userEmailError = payload
    },
    setFinalPhone(state, payload) {
      state.finalPhone = payload
    },
    setFinalEmail(state, payload) {
      state.finalEmail = payload
    },
    setSavedPhone(state, payload) {
      state.savedPhone = payload
    },
    setSavedEmail(state, payload) {
      state.savedEmail = payload
    },
  },
  getters: {
    timerStartTime(state) {
      return state.timerStartTime
    },
    membershipFeaturesText(state) {
      return state.membershipFeaturesText
    },
    membershipContractText(state) {
      // remove duplicates
      return state.membershipContractText.reduce(
        (previousValue, currentValue) => {
          return !previousValue.includes(currentValue)
            ? previousValue.concat(currentValue)
            : previousValue
        },
        [state.membershipContractText[0]]
      )
    },
    userEmailError(state) {
      return state.userEmailError
    },
    finalPhone(state) {
      return state.finalPhone
    },
    finalEmail(state) {
      return state.finalEmail
    },
    savedPhone(state) {
      return state.savedPhone
    },
    savedEmail(state) {
      return state.savedEmail
    },
  },
}
